import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/esm/Accordion';

import MenuItem from './MenuItem';

type TradingOffersMenuProps = {
  order: string;
  societyId: string;
  isActive: boolean;
};

const TradingOffersMenu: FC<TradingOffersMenuProps> = ({
  order,
  societyId,
  isActive,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey={order}>
        <li className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}>
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-coins" />
            </span>
            <span className="nk-menu-text">{t('EquityMarket')}</span>
          </a>
        </li>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={order}>
        <ul className="nk-menu-sub">
          <MenuItem
            linkTo={`/mercado-de-acciones/${societyId}`}
            text="EquityMarket"
          />
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default TradingOffersMenu;
